<template>
  <cube-page :title="titleStr" :isDefaultBack="false" @back="handleBack">
    <div slot="content" class="detail-content">
      <div class="detail-card">
        <div
          v-for="(item, index) in uiConfig"
          :key="item.code"
          class="detail-item"
          :class="{ 'no-border': index === uiConfig.length - 1 }"
        >
          <div class="item-label">{{ item.name }}</div>
          <div class="item-value">{{ formatValue(item.code, getDataItem(data, item.code)) }}</div>
        </div>
      </div>
    </div>
  </cube-page>
</template>

<script>
import CubePage from '@/components/cube-page'
import { queryMeta, getData as flowGetData } from '@/api/flow'
import { getData } from '@/api/tjls/index'
import { get } from 'lodash'
import ValueFormatter from '@/utils/valueFormatter'
import mockMeta from '../mockMeta/terminal-sales-analysis'

const DETAIL_CONFIG = {
  sales: {
    metaKey: 'original_sale',
    excludeFields: []
  },
  purchase: {
    metaKey: 'original_purchase',
    excludeFields: []
  },
  inventory: {
    metaKey: 'original_inventory',
    excludeFields: []
  }
}

export default {
  name: 'FormTableDetail',
  components: { CubePage },
  data() {
    return {
      uiConfig: [],
      data: {},
      fieldMeta: {}
    }
  },
  computed: {
    titleStr() {
      return this.$route.query.title + '详情'
    },
    formKey() {
      return this.$route.query.formKey
    },
    whereKey() {
      return this.$route.query.whereKey
    },
    whereValue() {
      return this.$route.query[this.whereKey]
    },
    isManualMode() {
      const { manualMode } = this.$route.query
      return manualMode === true || manualMode === 'true'
    },
    dataFlowType() {
      return this.$route.query.dataFlowType || 'sales'
    },
    detailConfig() {
      return DETAIL_CONFIG[this.dataFlowType] || DETAIL_CONFIG.sales
    },
    metaKey() {
      return this.formKey || this.detailConfig.metaKey
    }
  },
  mounted() {
    this.initPage()
  },
  activated() {
    this.initPage()
  },
  methods: {
    handleBack() {
      const fromRoute = this.$route.query.fromRoute
      if (fromRoute) {
        // 显式 replace 回列表，避免百度等浏览器 history.back 栈错乱
        this.$router.replace({ name: fromRoute })
      } else {
        this.$router.back()
      }
    },
    getDataItem(data, key) {
      if (Array.isArray(get(data, key))) {
        return get(data, key, '-').join()
      }
      return get(data, key, '-')
    },
    formatValue(fieldName, value) {
      const fieldConfig = this.fieldMeta[fieldName]
      if (!fieldConfig || !fieldConfig.format) {
        if (value === null || value === undefined || value === '') {
          return '-'
        }
        return value
      }
      return ValueFormatter.format(ValueFormatter.numbered(value), fieldConfig.format)
    },
    applyMeta(columns) {
      this.fieldMeta = columns
      const excludeFields = this.detailConfig.excludeFields || []
      const arr = Object.values(columns)
        .sort((a, b) => a.index - b.index)
        .filter(item => !item.isHidden && !excludeFields.includes(item.name))
      this.uiConfig = arr.map(item => ({
        name: item.label,
        code: item.name
      }))
    },
    loadMeta() {
      if (this.isManualMode) {
        const meta = mockMeta[this.metaKey]
        if (!meta) {
          return Promise.reject(new Error(`未找到 ${this.metaKey} 的 mock meta`))
        }
        this.applyMeta(meta.columns)
        return Promise.resolve()
      }
      return queryMeta(this.metaKey).then(res => {
        this.applyMeta(res.data.columns)
      })
    },
    loadDetailData() {
      if (this.isManualMode && this.$route.params.rowData) {
        this.data = this.$route.params.rowData
        return Promise.resolve()
      }

      const getDataApi = this.isManualMode ? getData : flowGetData
      const params = this.isManualMode
        ? {
          pageSize: 1,
          page: 1,
          dataFlowType: this.dataFlowType,
          [this.whereKey]: this.whereValue
        }
        : {
          where: [
            {
              field: this.whereKey,
              value: this.whereValue
            }
          ],
          select: this.uiConfig.map(item => item.code)
        }

      return getDataApi(this.metaKey, params).then(res => {
        this.data = get(res, 'data.items[0]', {})
      })
    },
    initPage() {
      this.loadMeta()
        .then(() => this.loadDetailData())
        .catch(error => {
          console.error('详情页加载失败:', error)
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/theme-variables.styl'

.detail-content
  background $page-bg-gradient
  min-height 100%
  padding $spacing-page

.detail-card
  background $card-bg
  border-radius $border-radius-item
  box-shadow 0 2px 12px rgba(100, 116, 139, 0.08)
  overflow hidden

.detail-item
  display flex
  justify-content space-between
  align-items flex-start
  padding 16px $spacing-page
  border-bottom 1px solid $border-normal

  &.no-border
    border-bottom none

  .item-label
    font-size 24px
    color $text-secondary
    flex-shrink 0
    max-width 40%

  .item-value
    font-size 24px
    color $text-primary
    text-align right
    flex 1
    margin-left 16px
    word-break break-all
</style>
